module.exports = __webpack_public_path__ + "static/media/upload-solid.049ec1d3.svg";